import { JobStatus } from '@prisma/client';
import { Tag, theme } from 'antd';

export type JobStatusRendererProps = {
  jobStatus?: JobStatus | null;
};

export const JobStatusRenderer = ({ jobStatus }: JobStatusRendererProps) => {
  const { token } = theme.useToken();

  let color = '#8c8c8c';
  let label = 'Unknown';

  switch (jobStatus) {
    case JobStatus.NEW:
      color = '#8c8c8c';
      label = 'New';
      break;
    case JobStatus.RUNNING:
      color = token.orange6;
      label = 'Running';
      break;
    case JobStatus.COMPLETED:
      color = token.green7;
      label = 'Completed';
      break;
    case JobStatus.ERROR:
      color = token.colorError;
      label = 'Error';
      break;
    case JobStatus.RETRY:
      color = token.yellow6;
      label = 'Retry';
      break;
    default:
      break;
  }

  return <Tag color={color}>{label}</Tag>;
};
